export const NumberOfCharacterShow = 45;
